import { get } from 'http';
import ApiClient from '../apiClient';

interface GetAccountsParams {
  page?: number;
  page_size?: number;
  search?: string;
  sort_by?: string;
}

const clientAccService = {
  getAccounts: (params?: GetAccountsParams) => {
    const queryParams = new URLSearchParams();
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.page_size) queryParams.append('page_size', params.page_size.toString());
    if (params?.search) queryParams.append('name', params.search);
    if (params?.sort_by && params.sort_by.trim()) queryParams.append('sort_by', params.sort_by);

    const queryString = queryParams.toString();
    const url = queryString ? `/models?${queryString}` : '/models';
    return ApiClient.get(url);
  },
  createAccount: (data: any) => ApiClient.post('/models', data),

  createConfirmCode: (modelName: any) => ApiClient.post(`/models/${modelName}/confirm_code`, {}),
  checkConfirmCode: (modelName: any) => ApiClient.get(`/models/${modelName}/confirm_code`),
  setCredentials: (modelId: any, credentials: any) =>
    ApiClient.post(`/models/${modelId}/credentials`, credentials),
  workMedia: (modelId: any, mediaData: any) =>
    ApiClient.post(`/models/${modelId}/media/work`, mediaData),
  publicMedia: (modelId: any, mediaData: any) =>
    ApiClient.post(`/models/${modelId}/media/public`, mediaData),
  deletePublicMedia: (modelId: any, mediaId: any) =>
    ApiClient.delete(`/models/${modelId}/media/public/${mediaId}`),
  // POST /models/{model_id}/guarantee
  depositGuarantee: (modelId: any, amount: any) =>
    ApiClient.post(`/models/${modelId}/guarantee`, { amount }),
  requestGuaranteeRefund: (modelId: any) => ApiClient.post(`/models/${modelId}/guarantee/refund`, {}),
  getInvoices: (modelId: any, params?: any) =>
    ApiClient.get(`/models/${modelId}/invoices`, { params }),
  getInvoiceById: (modelId: any, invoiceId: any) =>
    ApiClient.get(`/models/${modelId}/invoices/${invoiceId}`),
  getCampaigns: (modelId: any, params?: any) =>
    ApiClient.get(`/models/${modelId}/campaigns`, { params }),
  getCampaignById: (modelId: any, campaignId: any) =>
    ApiClient.get(`/models/${modelId}/campaigns/${campaignId}`),
  getModelById: (modelId: any) => ApiClient.get(`/models/${modelId}`),
};

export default clientAccService;
